import axios from 'axios';
import { auth } from '@strapi/helper-plugin';

let axiosClient;

export const createAxiosClient = (strapi) => {
  if (!strapi) {
    throw new Error(
      'Strapi instance is required to initialize axios client',
    );
  }

  const strapiBackendURL = strapi?.backendURL.length
    ? strapi.backendURL
    : window.location.origin;

  axiosClient = axios.create({
    baseURL: strapiBackendURL,
  });

  axiosClient.interceptors.request.use(
    (config) => {
      const token = auth?.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  return axiosClient;
};

export const getAxiosClient = () => {
  if (!axiosClient) {
    throw new Error(
      'Axios client is not initialized. Call createAxiosClient first.',
    );
  }
  return axiosClient;
};
